import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { ProtestInfoService } from "src/app/services/protest-info.service";
import {catchError, finalize, throwError} from "rxjs";
import {UtilService} from "../../services/util.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-payment-status',
    templateUrl: './payment-status.component.html',
    styleUrl: './payment-status.component.scss',
    standalone: false
})
export class PaymentStatusComponent implements OnInit {
  token: string | null = null;
  loading = true;

  constructor(private activatedRoute: ActivatedRoute, private protestInfoService: ProtestInfoService,
              private util: UtilService, private router: Router) {
  }

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('token');
    if (this.token)
    {
      console.log("Received token: " + this.token);

      var aNum = this.protestInfoService.getA_Num();
      this.protestInfoService.checkTransactionStatus(aNum, this.token).pipe(
        finalize(() => {
          this.loading = false;
        }),
        catchError(e => {
          console.error("Error in payGovCollection:", e);
          return throwError(e);
        })
      ).subscribe(r => {
        console.log("Response received:", r);

        if (r.isPaymentSuccess == "Y") {
          this.util.displayDialogMessage("Payment Success!",
            "Your payment to pay.gov has been received.<br>Your payment tracking id is: " + r.payDotGovTrackingId)
            .subscribe(() => {
              this.router.navigate([this.util.getDashboardURL()]);
            });
        } else {
          let message = "There was an error checking the transaction status. Please don't file the protest again. Instead, contact PLCG at protests@gao.gov. Potentially a back button or refresh was accidentally done to cause this error. If the case shows in your dashboard, you have successfully paid";
          if (r.payDotGovError && r.payDotGovError.errorDetail)
            message += "<br><br>Detail: " + r.payDotGovError.errorDetail;

          this.util.displayDialogMessage("Error or Payment Failed!", message)
            .subscribe(() => {
              this.router.navigate([this.util.getDashboardURL()]);
            });
        }
      });
    }
  }
}
